import React from "react";

const QuerySummaryItem = ({
  displayName = "Loading...",
  markText = null,
  onClick,
  selected = false,
  entity = null,
}) => {
  // Strip "smiles:" or "query:" prefix from display name
  const cleanDisplayName = displayName.replace(/^(smiles|query):/i, '');

  return (
    <li className={`long-text ${selected ? " selected" : ""}`} onClick={onClick}>
      {markText ? markText(cleanDisplayName) : cleanDisplayName}
    </li>
  );
};

export default QuerySummaryItem;
